<div>
  <!-- Filtros de Pesquisa -->
  <div class="filters-section">
    <mat-card class="filters-card">
      <mat-card-title class="filters-header">
        <div class="title-section">
          <mat-icon class="filter-icon">filter_list</mat-icon>
          <span>Filtros de Resgates</span>
          @if (hasActiveFilters()) {
            <span class="filter-indicator">
              <mat-icon>fiber_manual_record</mat-icon>
              Ativos
            </span>
          }
        </div>
        <button mat-icon-button (click)="toggleFilters()" class="toggle-filters">
          <mat-icon>{{filtersExpanded ? 'expand_less' : 'expand_more'}}</mat-icon>
        </button>
      </mat-card-title>

      @if (filtersExpanded) {
        <mat-card-content class="filters-content">
          <div class="filters-grid">
            <!-- Filtro de Busca (mantido do original) -->
            <mat-form-field class="example-full-width search-doctor filter-field" appearance="outline">
              <mat-label>
                <mat-icon>search</mat-icon>
                Resgate
              </mat-label>
              <input type="text"
                     placeholder="Informe o nome, id"
                     aria-label="Pedido"
                     matInput
                     (input)="search($event.target.value)">
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>

            <!-- Data Início -->
            <mat-form-field appearance="outline" class="filter-field">
              <mat-label>
                <mat-icon>calendar_today</mat-icon>
                Data Início
              </mat-label>
              <input matInput
                     [matDatepicker]="dataInicioPicker"
                     [formControl]="dataInicio"
                     placeholder="DD/MM/AAAA"
                     (dateChange)="onDateInputChange($event, 'dataInicio')">
              <mat-datepicker-toggle matSuffix [for]="dataInicioPicker"></mat-datepicker-toggle>
              <mat-datepicker #dataInicioPicker></mat-datepicker>
              <mat-hint>Data inicial do período</mat-hint>
            </mat-form-field>

            <!-- Data Fim -->
            <mat-form-field appearance="outline" class="filter-field">
              <mat-label>
                <mat-icon>event</mat-icon>
                Data Fim
              </mat-label>
              <input matInput
                     [matDatepicker]="dataFimPicker"
                     [formControl]="dataFim"
                     placeholder="DD/MM/AAAA"
                     (dateChange)="onDateInputChange($event, 'dataFim')">
              <mat-datepicker-toggle matSuffix [for]="dataFimPicker"></mat-datepicker-toggle>
              <mat-datepicker #dataFimPicker></mat-datepicker>
              <mat-hint>Data final do período</mat-hint>
            </mat-form-field>

            <!-- Status -->
            <app-searchable-select
              class="filter-field"
              [options]="statusOptions"
              [selected]="selectedStatuses.value || []"
              (selectedChange)="selectedStatuses.setValue($event)"
              label="Status"
              icon="check_circle"
              hint="Digite ou selecione status"
              [multiple]="true">
            </app-searchable-select>

            <!-- UF -->
            <app-searchable-select
              class="filter-field"
              [options]="ufOptions"
              [selected]="selectedUfs.value || []"
              (selectedChange)="selectedUfs.setValue($event)"
              label="UF"
              icon="location_on"
              hint="Digite ou selecione UFs"
              [multiple]="true">
            </app-searchable-select>

            <!-- KIT -->
            <app-searchable-select
              class="filter-field"
              [options]="kitOptions"
              [selected]="selectedKits.value || []"
              (selectedChange)="selectedKits.setValue($event)"
              label="KIT"
              icon="category"
              hint="Digite ou selecione KITs"
              [multiple]="true">
            </app-searchable-select>
          </div>

          <div class="filter-actions">
            <button mat-raised-button color="primary" (click)="getRescues()" class="search-btn">
              <mat-icon>search</mat-icon>
              Pesquisar
            </button>
            <button mat-stroked-button (click)="clearFilters()" class="clear-btn">
              <mat-icon>refresh</mat-icon>
              Limpar Filtros
            </button>
          </div>
        </mat-card-content>
      }
    </mat-card>
  </div>

  <!-- Tabela de Resgates -->
  @if(loading){
    <div class="page-loader">
      <mat-spinner></mat-spinner>
    </div>
  }@else{

    <!-- Botões da lista, lado a lado. Ficam fora do bloco da tabela: some a
         tabela quando a busca não traz nada, mas as ações continuam à vista. -->
    <div class="example-flex-container">
      <input
        #csvInput
        type="file"
        accept=".csv,text/csv"
        class="input-arquivo"
        tabindex="-1"
        aria-hidden="true"
        (change)="onCsvSelected(csvInput.files)" />

      <button
        class="acao-btn acao-btn--upload"
        (click)="csvInput.click()"
        [disabled]="listaVazia()"
        matFab
        extended
        [matTooltip]="listaVazia()
          ? 'Busque os pedidos primeiro: a planilha seleciona dentro da lista carregada'
          : 'Selecionar pedidos a partir de uma planilha com a coluna número do pedido'">
        <mat-icon>upload_file</mat-icon>
        Selecionar por planilha
      </button>

      <button
        class="acao-btn"
        (click)="downloadReport()"
        [disabled]="listaVazia()"
        matFab
        extended
        [matTooltip]="listaVazia() ? 'Nenhum pedido para exportar' : 'Exportar a lista para Excel'">
        <mat-icon>file_download</mat-icon>
        Exportar para Excel
      </button>
    </div>

    @if(listaVazia()){
      <p>Nenhum resgate encontrado!</p>
    }@else{

    @if (resumoImportacao) {
      <div class="import-resultado">
        <span class="chip ok">{{resumoImportacao.validos}} selecionados pela planilha</span>
        @if (resumoImportacao.invalidos.length) {
          <span class="chip erro">{{resumoImportacao.invalidos.length}} não encontrados</span>
          <button mat-button (click)="baixarInvalidos()">
            <mat-icon>file_download</mat-icon>
            Baixar não encontrados
          </button>
        }
        <span class="arquivo-nome">{{resumoImportacao.arquivo}}</span>
      </div>
    }

    @if(showEditButton()){
      <div class="editar-container">
        <button
          matFab
          extended
          color="primary"
          (click)="editar('0ms', '0ms')"
          matTooltip="Altera o status dos pedidos selecionados">
          <mat-icon>edit</mat-icon>
          Editar status
        </button>
      </div>
    }

    <table mat-table [dataSource]="matDataSource" class="mat-elevation-z8">
      <!-- ID -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="toggleAllRows($event)"
            [checked]="isAllSelected()"
            [indeterminate]="isAnySelectedButNotAll()"
          ></mat-checkbox> Tudo</th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="toggleSingleRow(row)"
            [checked]="selection.has(row)"
          ></mat-checkbox>
        </td>
      </ng-container>

      <!-- Nome -->
      <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef>Nome</th>
        <td mat-cell *matCellDef="let row">{{ row.nome }} <span *ngIf="row.verificar_medico === true">🟡</span></td>
      </ng-container>

      <ng-container matColumnDef="kit">
        <th mat-header-cell *matHeaderCellDef>Kit</th>
        <td mat-cell *matCellDef="let row">{{ row.kit }}</td>
      </ng-container>

      <ng-container matColumnDef="produto">
        <th mat-header-cell *matHeaderCellDef>Produto</th>
        <td mat-cell *matCellDef="let row">{{ row.produto }}</td>
      </ng-container>

      <ng-container matColumnDef="numero_pedido">
        <th mat-header-cell *matHeaderCellDef>Nº Pedido</th>
        <td mat-cell *matCellDef="let row">{{ row.numero_pedido }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row">
          <span class="status-badge" [ngClass]="getStatusClass(row.status_descricao)">
            {{ statusDescricao(row.status_descricao) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="data">
        <th mat-header-cell *matHeaderCellDef>Data</th>
        <td mat-cell *matCellDef="let row">{{ formatDate(row.criacao)}}</td>
      </ng-container>

      <!--<ng-container matColumnDef="historico">
        <th mat-header-cell *matHeaderCellDef>Histórico</th>
        <td mat-cell *matCellDef="let row">
          <button
            mat-icon-button
            (click)="verHistorico(row)"
            matTooltip="Ver quem alterou este pedido">
            <mat-icon>history</mat-icon>
          </button>
        </td>
      </ng-container>-->

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [length]="100"
                  [pageSize]="10"
                  [pageSizeOptions]="[5, 10, 25, 100]"
                  aria-label="Select page">
    </mat-paginator>
    }
  }
</div>

<!-- Legenda de Cores dos Status -->
<div class="legend-cores">
  <div class="legend-title">Legenda de Cores dos Status</div>
  <div class="legend-items">
    <div class="legend-item">
      <div class="color-box" [style.background-color]="getStatusColor('PENDENTE')"></div>
      <span class="color-label">Pendente</span>
    </div>
    <div class="legend-item">
      <div class="color-box" [style.background-color]="getStatusColor('APROVADO')"></div>
      <span class="color-label">Aprovado</span>
    </div>
    <div class="legend-item">
      <div class="color-box" [style.background-color]="getStatusColor('ENVIADO')"></div>
      <span class="color-label">Enviado</span>
    </div>
    <div class="legend-item">
      <div class="color-box" [style.background-color]="getStatusColor('ENTREGUE')"></div>
      <span class="color-label">Entregue</span>
    </div>
    <div class="legend-item">
      <div class="color-box" [style.background-color]="getStatusColor('CANCELADO')"></div>
      <span class="color-label">Cancelado pelo Participante</span>
    </div>
    <div class="legend-item">
      <div class="color-box" [style.background-color]="getStatusColor('CANCELADO_PELO_PROGRAMA')"></div>
      <span class="color-label">Cancelado pelo Programa</span>
    </div>
    <div class="legend-item">
      <div class="color-box" style="background-color: #ffd300; border-radius: 25px;"></div>
      <span class="color-label">Verificar especialidades em CFM</span>
    </div>
  </div>
</div>
